import { graphql } from 'gql.tada';

// --- Backoffice namespace ---

export const GET_BUYERS = graphql(`
    query searchBuyers(
        $filter: BuyerSearchFilterInput,
        $orderBy: BuyerSearchOrderByInput,
        $pagination: BuyerSearchPaginationInput
    ) {
        buyers {
            backoffice(
                filter: $filter,
                orderBy: $orderBy,
                pagination: $pagination
            ) {
                count
                items {
                    billingEmail
                    broadcastLanguage
                    broadcastCountries {
                        countries
                        main
                    }
                    broadcastType
                    contactEmail
                    contactName
                    hourCost
                    identifier {
                        id
                        sku
                    }
                    legalName
                    licensesDuration
                    payoutTemplate
                    postalAddress
                    publicName
                    replayRights
                    vatId
                    videoOutputBitrate
                    videoOutputFormat
                    businessProvider {
                        identifier {
                            sku
                            id
                        }
                        contactName
                    }
                }
            }
        }
    }
`);

export const GET_BUYER = graphql(`
    query buyer($id: UUID) {
        buyer(id: $id) {
            backoffice {
                contactEmail
                contactName
                identifier {
                    id
                    sku
                }
                legalName
                postalAddress
                publicName
                replayRights
                videoOutputBitrate
                videoOutputFormat
                billingEmail
                broadcastLanguage
                vatId
            }
        }
    }
`);

export const GET_BUYER_SUMMARY = graphql(`
    query buyerSummary($id: UUID) {
        buyer(id: $id) {
            backoffice {
                identifier {
                    id
                }
                legalName
                publicName
                contactName
                broadcastLanguage
                videoOutputBitrate
                videoOutputFormat
                broadcastCountries {
                    countries
                    main
                }
                payinIban
            }
        }
    }
`);

export const UPDATE_BUYER = graphql(`
    mutation updateBuyer(
        $id: UUID!,
        $input: UpdateBuyerInput!
    ) {
        buyer {
            backoffice {
                update(id: $id, input: $input) {
                    identifier {
                        id
                        sku
                    }
                }
            }
        }
    }
`);

export const CREATE_BUYER = graphql(`
    mutation createBuyer(
        $input: CreateBuyerInput!
    ) {
        buyer {
            backoffice {
                create(input: $input) {
                    identifier {
                        id
                        sku
                    }
                }
            }
        }
    }
`);

// --- Account namespace (webapp usage) ---

export const GET_BUYER_ACCOUNT = graphql(`
    query buyerAccount($id: UUID) {
        buyer(id: $id) {
            account {
                identifier {
                    id
                    sku
                }
                contactName
                contactEmail
                publicName
                postalAddress
                billingEmail
                legalName
                vatId
                videoOutputFormat
                videoOutputBitrate
                broadcastCountries {
                    countries
                    main
                }
                broadcastLanguage
            }
        }
    }
`);

export const UPDATE_BUYER_ACCOUNT = graphql(`
    mutation updateBuyerAccount(
        $input: UpdateBuyerAccountInput!
    ) {
        buyer {
            account {
                update(input: $input) {
                    identifier {
                        id
                        sku
                    }
                }
            }
        }
    }
`);
